import { gql } from '@apollo/client'

import DICTIONARY_WORD_FRAGMENT from './dictionary-word-fragment'

const DICTIONARY_WORDS_FRAGMENT = gql`
  fragment DictionaryWordsFragment on DictionaryWords {
    results {
      ...DictionaryWordFragment
    }
    total
  }
  ${DICTIONARY_WORD_FRAGMENT}
`

export default DICTIONARY_WORDS_FRAGMENT
